export default __webpack_public_path__ + "static/media/analytics.d3714442.png";